<template>
  <transition name="modal">
    <div class="modal__mask" @touchmove.stop>
      <div class="modal__wrapper">
        <div v-if="alertContent.content.title" class="modal__title">
          <p v-html="alertContent.content.title"></p>
        </div>

        <div :class="alertContent.content.title ? 'modal__box-with-title' : 'modal__box'">
          <div class="modal__header">
            <p v-html="alertContent.content.header"></p>
          </div>
          <div class="modal__body">
            <p v-html="alertContent.content.body"></p>
          </div>
          <div class="modal__footer">
            <p v-if="alertContent.content.footer" class="modal__footer_text" v-html="alertContent.content.footer"></p>
            <div class="modal__footer_button_container">
              <button
                v-for="(item, index) of alertContent.alertItems"
                :key="index"
                :class="classWithItemType(item.type)"
                @click="$emit('alertButtonClick', index)"
              >
                {{ item.title }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    alertContent: {
      content: {
        header: String,
        body: String,
      },
      alertItems: Array,
    },
  },
  methods: {
    classWithItemType: function (type) {
      if (type === 'preffered') {
        return 'modal__button modal__buttonPreferred'
      } else {
        return 'modal__button'
      }
    },
  },
}
</script>

<style scoped>
.modal__mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal__wrapper {
  vertical-align: middle;
  position: absolute;
  max-height: 90vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.modal__body > p {
  text-align: left;
}

.modal__box {
  max-width: min(355px, 90vw);
  margin: 0px auto;
  border-radius: 16pt;
  transition: all 0.2s ease-in-out;
  width: 100%;
  padding: 30px 26px 20px;
  background-color: white;
  text-align: center;
}

.modal__box-with-title {
  max-width: min(355px, 90vw);
  margin: 0px auto;
  border-radius: 0pt 0pt 16pt 16pt;
  transition: all 0.2s ease-in-out;
  width: 100%;
  padding: 20px 26px 20px;
  background-color: white;
  text-align: center;
}

.modal__header {
  margin-top: 0;
  color: black;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0pt;
}

.modal__title {
  margin-top: 0;
  background-color: #ff003d;

  max-width: min(355px, 90vw);
  margin: 0px auto;
  border-radius: 16pt 16pt 0 0;
  transition: all 0.2s ease-in-out;
  padding: 10px 26px 10px 26px;

  color: white;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0pt;
}

.modal__body {
  color: black;
  margin: 20px 0;
  font-size: 14px;
  color: rgb(38, 38, 38);
}

.modal__footer {
  align-content: center;
  width: 100%;
}

.modal__footer_text {
  color: #808080;
  font-size: 13px;
  margin-bottom: 10px;
}

.modal__footer_button_container {
  display: flex;
  justify-content: space-around;
  width: 100%;
}

.modal__button {
  height: 50px;
  width: 126px;
  background-color: #f2f2f2;
  border-radius: 25pt;
  color: #0f0f0f;
  border-width: 0px;
  font-size: 16px;
}

.modal__buttonPreferred {
  color: white;
  background-color: #188dff;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
